const Nav = () => {
    return (
        <nav>
            <strong id="logo">Emojipedia</strong>            
        </nav>
    );
}

export default Nav;